import { Button } from '@components/ui'
import { Col } from 'antd'

import { Entities_WebFlow_TutorialsGameExamples_GameExample } from '@suntex.fim/api-client'
import { ResourceList } from '@suntex.fim/ui'

import ExploreLink from './ExploreLink'
import { openVideo } from './util'

type GameExampleSubCategoryProps = {
  subCategory: NonNullable<
    Entities_WebFlow_TutorialsGameExamples_GameExample['subCategories']
  >[number]
}

function GameExampleSubCategory({
  subCategory
}: Readonly<GameExampleSubCategoryProps>) {
  const handleGameExampleClick = (mediaId: string, friendlyName: string) => {
    openVideo(mediaId, friendlyName)
  }

  return (
    <Col xs={24} md={8} key={subCategory.name}>
      <ResourceList title={subCategory.name} titleLevel="h6">
        <ul className="resources-list">
          {subCategory.games?.map((subCategoryItem) => (
            <li key={subCategoryItem.name}>
              <div className="resources-item">
                <div className="resources-item__title fw-bold">
                  {subCategoryItem['game-link'] ? (
                    <ExploreLink
                      url={subCategoryItem['game-link'] ?? ''}
                      title={subCategoryItem.name ?? ''}
                    />
                  ) : (
                    <Button
                      intent="icon"
                      className="getting-started-btn"
                      onClick={() =>
                        handleGameExampleClick(
                          subCategoryItem['media-id'] ?? '',
                          subCategoryItem['friendly-name'] ?? ''
                        )
                      }
                    >
                      {subCategoryItem.name ?? ''}
                    </Button>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </ResourceList>
    </Col>
  )
}

export default GameExampleSubCategory
